// extracted by mini-css-extract-plugin
export var attachmentContainer = "_md-0";
export var fileList = "_md-2";
export var removeFileButton = "_md-1";